import React from 'react';
import ButtonStyles from './Button.module.css';

const Button = ({
	label,
	children,
	style,
	onClick,
	type = 'button',
	variant = 'primary',
	disabled = false,
	...rest
}) => {
	// Use children if provided, otherwise fall back to label (for backward compatibility)
	const buttonText = children || label;
	
	// Determine the CSS class based on variant
	let variantClass = ButtonStyles.button; // default to primary
	if (variant === 'secondary') {
		variantClass = ButtonStyles.buttonSecondary;
	} else if (variant === 'danger') {
		variantClass = ButtonStyles.buttonDanger;
	}
	
	return (
		<button 
			className={variantClass} 
			style={style} 
			onClick={onClick} 
			type={type}
			disabled={disabled}
			data-testid='btn-component'
			{...rest}
		>
			{buttonText}
		</button>
	);
};

export default Button;
